import { components as c } from "@/components";
import { SurgeryCliniciansFormFields } from "@/features/events/features/surgeries/components/SurgeryCliniciansFormFields";
import { useTemplateNavigationStore } from "@/features/templates/hooks/useTemplateNavigationStore";
import { useTemplateStore } from "@/features/templates/stores/useTemplateStore";
import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as z from "zod";

const surgeryFormSchema = z.object({
  referring_clinician_id: z.string().uuid().optional().nullable(),
  operating_clinician_id: z.string().uuid().optional().nullable(),
});

type SurgeryFormValues = z.infer<typeof surgeryFormSchema>;

const SurgeryFormFieldsPage = () => {
  const {
    referring_clinician_id,
    operating_clinician_id,
    organisation_id,
    setSurgeryReferringClinicianId,
    setSurgeryOperatingClinicianId,
  } = useTemplateStore();

  const {
    markStepComplete,
    nextStep,
    setCurrentStep,
    getNextStepRoute,
    getPreviousStepRoute,
    currentStep,
  } = useTemplateNavigationStore();
  const navigate = useNavigate();
  const { templateId } = Route.useParams();

  useEffect(() => {
    setCurrentStep("surgery");
  }, [setCurrentStep]);

  const form = useForm<SurgeryFormValues>({
    resolver: zodResolver(surgeryFormSchema),
    defaultValues: {
      referring_clinician_id: referring_clinician_id,
      operating_clinician_id: operating_clinician_id,
    },
  });

  const handleNext = (formData: SurgeryFormValues) => {
    setSurgeryReferringClinicianId(
      formData?.referring_clinician_id ?? null,
    );
    setSurgeryOperatingClinicianId(
      formData?.operating_clinician_id ?? null,
    );

    markStepComplete(currentStep);
    nextStep();
    const nextRoute = getNextStepRoute(currentStep, { templateId });
    if (nextRoute) navigate(nextRoute);
  };

  const handlePrevious = () => {
    const prevRoute = getPreviousStepRoute(currentStep, { templateId });
    if (prevRoute) navigate(prevRoute);
  };

  return (
    <c.ui.Form {...form}>
      <form onSubmit={form.handleSubmit(handleNext)}>
        <SurgeryCliniciansFormFields organisationId={organisation_id} />

        {/* Navigation Buttons */}
        <div className="flex justify-between gap-4 mt-8">
          <c.ui.Button
            type="button"
            variant="outline"
            onClick={handlePrevious}
          >
            Previous
          </c.ui.Button>

          <c.ui.Button type="submit">Next</c.ui.Button>
        </div>
      </form>
    </c.ui.Form>
  );
};

export const Route = createFileRoute(
  "/_app/new/diary/$templateId/events/surgery/",
)({
  component: SurgeryFormFieldsPage,
});
